import { apiV2PowerRoomConfigUpdateCircuitSwitchStatusPost } from '@maxtropy/device-customer-apis-v2';
import { Button, Modal, Form, Tag, ShowInput, PopConfirm } from '@maxtropy/components';
import React, { FC, useEffect, useState } from 'react';
import { SwitchStatusType } from '@/api/circuit';
import { Spin } from 'antd';

interface SwitchControlModalProps {
  visible: boolean;
  onCancel: () => void;
  onOk: (status: SwitchStatusType) => void;
  circuitInfo: any;
}

const SwitchControlModal: FC<SwitchControlModalProps> = props => {
  const { visible, onCancel, circuitInfo, onOk } = props;
  const [form] = Form.useForm();
  const [switchStatus, setSwitchStatus] = useState<SwitchStatusType>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    if (visible) {
      setSwitchStatus(circuitInfo?.switchStatus);
    }
  }, [circuitInfo, visible]);

  const confirmText = switchStatus === SwitchStatusType.OPEN ? '确定合闸吗？' : '确定开闸吗？';

  const handleConfirm = () => {
    setIsLoading(true);
    apiV2PowerRoomConfigUpdateCircuitSwitchStatusPost({
      id: circuitInfo.id,
      status: switchStatus === SwitchStatusType.CLOSE ? SwitchStatusType.OPEN : SwitchStatusType.CLOSE,
    })
      .then(_ => {
        onOk?.(switchStatus === SwitchStatusType.CLOSE ? SwitchStatusType.OPEN : SwitchStatusType.CLOSE);
        onCancel();
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <Modal
      title="开关控制"
      open={visible}
      size="small"
      onCancel={onCancel}
      footer={[
        <Button key={'cancel'} onClick={onCancel}>
          关闭
        </Button>,
      ]}
      getContainer={document.body} // ✅ 挂到 body，避免被容器遮挡
      zIndex={2000}
    >
      <Spin spinning={isLoading}>
        <Form form={form} layout="horizontal" style={{ padding: '20px' }}>
          <Form.Item label="回路名称">
            <ShowInput value={circuitInfo?.name || ''} />
          </Form.Item>
          <Form.Item label="开关状态">
            {switchStatus === SwitchStatusType.OPEN ? (
              <Tag border="solid" color="success">
                开闸状态
              </Tag>
            ) : switchStatus === SwitchStatusType.CLOSE ? (
              <Tag border="solid" color="error">
                合闸状态
              </Tag>
            ) : (
              <Tag border="solid" color="invalid">
                无
              </Tag>
            )}
          </Form.Item>
          <Form.Item label="操作类型">
            <div style={{ marginLeft: -14 }}>
              <PopConfirm placement="top" title={confirmText} onConfirm={handleConfirm}>
                <Button type="link" disabled={switchStatus === SwitchStatusType.CLOSE}>
                  合闸
                </Button>
              </PopConfirm>
              <PopConfirm placement="top" title={confirmText} onConfirm={handleConfirm}>
                <Button type="link" disabled={switchStatus === SwitchStatusType.OPEN}>
                  开闸
                </Button>
              </PopConfirm>
            </div>
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};

export default SwitchControlModal;
